import { render, staticRenderFns } from "./orderNxSend.vue?vue&type=template&id=fde001e4&scoped=true"
import script from "./orderNxSend.vue?vue&type=script&lang=js"
export * from "./orderNxSend.vue?vue&type=script&lang=js"
import style0 from "./orderNxSend.vue?vue&type=style&index=0&id=fde001e4&prod&scoped=true&lang=css"
import style1 from "./orderNxSend.vue?vue&type=style&index=1&id=fde001e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde001e4",
  null
  
)

export default component.exports